import { render } from "./Container.vue?vue&type=template&id=96c35876"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"
script.render = render

export default script